import { useMantineTheme } from "@mantine/core"
import {
  IconSelector,
  IconChevronUp,
  IconChevronDown,
} from "@tabler/icons-react"
import { SortDirection } from "@tanstack/react-table"

type Props = {
  sortOrder: SortDirection | false
  iconSize?: number
}

export const SortIcon = ({ sortOrder, iconSize = 16 }: Props) => {
  const { colors } = useMantineTheme()
  switch (sortOrder) {
    case "asc":
      return <IconChevronUp color={colors.gray[5]} size={iconSize} />
    case "desc":
      return <IconChevronDown color={colors.gray[5]} size={iconSize} />
    default:
      return <IconSelector color={colors.gray[5]} size={iconSize} />
  }
}
